export default "__VITE_ASSET__D14v3I35__"